import React, { Fragment, useEffect, useState } from 'react'
import { Button } from 'antd';

import IframeUrl from './Utils';
import { COLOREDBAR } from '../../config/media';
import { MetricsLogsWrapper } from './style';

const Logs = ({ getData, handleNavigateLogs, goLive, type, props }) => {

    const [iframeData, setIframeData] = useState([]);

    useEffect(() => {
        const getUrl = async () => {
            const res = await getData();
            setIframeData(res && res.data);
        }
        getUrl()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onHandleMetrics = () => {
        handleNavigateLogs();
    }

    const onHandleNav = () => {
        props.history.push('/billing');
    }

    return (
        <MetricsLogsWrapper>
            <div className='cloud-logs-wrapper d-flex'>
                <div className='d-flex content-wrapper'>
                    <Fragment>
                        <img className='metric-log-icon' alt='colored-bar' src={COLOREDBAR}></img>
                    </Fragment>
                    <div className='d-flex cloud-content'>
                        <span className='text-white bold header-title'>Cloud logs</span>
                        {type && type === 'Cloud' ?
                            <div className='text-white'>Here are real-time data logs from your cloud exchange.</div>
                            : <div className='text-white'> Logs are only displayed for {<span onClick={onHandleNav} className='cloud-link'>cloud exchanges.</span>
                            }</div>}
                    </div>
                </div>
                <div className='logs-btn'>
                    <Button type='primary' onClick={onHandleMetrics}>View Metrics</Button>
                </div>
            </div>
            <div className='iframe-wrapper'>
                <IframeUrl className={'logs-wrapper'} title={'Logs'} subTitle={'logs'} iframeData={iframeData && iframeData.logs} handleNav={goLive} iframeType={'logs'} />
                <IframeUrl className={'log-rates-wrapper'} title={'Log rates'} subTitle={'logRates'} iframeData={iframeData && iframeData.logrates} handleNav={goLive} iframeType={'logs'} />
            </div>
        </MetricsLogsWrapper>
    )
}

export default Logs;
